module.exports = "/virtual-football-league/img/amblems/right/logos/LEGANES.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/LEGANES.png
// module id = 2205
// module chunks = 4